import * as React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import { Calendar, CalendarProps, Slot } from '@crochik/pi-react/ui/material/Calendar2';
import { CustomPage } from '@crochik/pi-react/application/Page';
import { Default } from '@crochik/pi-react/context';
import DataService from '@crochik/pi-react/services/DataService';

import CircularProgress from '@material-ui/core/CircularProgress';
import { ReadOnlyForm } from '@crochik/pi-react/ui/material/ReadOnlyForm';

export interface ICalendarState {
    selectedSlot?: Slot;
    calendarProps?: CalendarProps;
}

@observer
export class CalendarPage extends React.Component {
    boundState: ICalendarState;

    static get state(): ICalendarState {
        var state = Default.state.get('Calendar', 'page');
        if (!state) {
            var initial: ICalendarState = {
                selectedSlot: undefined,
                calendarProps: undefined
            };
            state = observable(initial);
            Default.state.set('Calendar', state, 'page');
        }
        return state;
    }

    constructor(props: any) {
        super(props);
        this.boundState = CalendarPage.state;
    }

    componentDidMount() {
        this.load();
    }

    async load(): Promise<any> {
        var slots: CalendarProps | null = await DataService().select('Slots');

        if (!slots || !slots.days || slots.days.length < 1) {
            Default.actions.execute('skipAppointment', 'page.Calendar');
            return;
        }

        this.boundState.calendarProps = slots;
    }

    @action
    onClickSlot = (slot: Slot) => {
        Default.actions.execute('onClick', 'page.Calendar', slot);
    }

    render() {
        if (!this.boundState.calendarProps) {
            return (
                <div className="pi-content">
                    <div className="pi-progress"><CircularProgress size={100} color="primary" /></div>
                </div>
            );
        }

        var selectedSlots = this.boundState.selectedSlot ?
            { [this.boundState.selectedSlot.id]: true } :
            undefined;

        var props: CalendarProps = {
            ...this.boundState.calendarProps,
            onClick: this.onClickSlot,
            selectedSlots
        };

        var existingLead = Default.state.get('startArgs.auth', 'app');
        if (existingLead) {
            return (
                <div className="pi-content">
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ height: '100%', width: 300, flexShrink: 0 }}>
                            <ReadOnlyForm form="Lead" autoFocus={false} />
                        </div>

                        <div style={{ height: 'calc(100vh - 100px)' }}>
                            <Calendar {...props} collapseDays={true} />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="pi-content">
                <Calendar {...props} collapseDays={true} />
            </div>
        );
    }
}

export default (name: string, title: string) => new CustomPage({ name, label: title }, <CalendarPage />);


// WEBPACK FOOTER //
// ./src/app/pages/Calendar.tsx